import Vue from "vue";
import Router from "vue-router";
import Main from "@/views/Main.vue";
import Login from "@/views/Login.vue";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        auth: false,
        title: "Login"
      }
    },
    {
      path: "/",
      name: "base",
      component: Main,
      meta: {
        auth: true,
        title: "Main"
      },
      children: [{
        path: "",
        name: "dashboard-normal",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          title: "Hello"
        }
      }]
    },
    {
      path: "/admin",
      name: "main-admin",
      component: Main,
      meta: {
        auth: 'admin'
      },
      children: [{
          path: "",
          name: "dashboard-admin",
          component: () => import("@/views/Dashboard.vue"),
          meta: {
            title: "Hello"
          }
        },
        {
          path: "projects",
          name: "projects",
          component: () => import("@/views/Projects.vue"),
          meta: {
            title: "Projects"
          }
        },
        {
          path: "events",
          name: "event-list",
          component: () => import("@/views/Events.vue"),
          meta: {
            title: "Events"
          }
        },
        {
          path: "projects/:id",
          name: "project-edit",
          component: () => import("@/views/project/Edit.vue"),
          meta: {
            title: "Edit Project"
          }
        },
        {
          path: "events/:id",
          name: "event-edit",
          component: () => import("@/views/event/Edit.vue"),
          meta: {
            title: "Edit Event"
          }
        },
        {
          path: "datasources",
          name: "datasources",
          component: () => import("@/views/Datasources.vue"),
          meta: {
            title: "Datasources"
          }
        },
        {
          path: "datasources/:id",
          name: "datasource-edit",
          component: () => import("@/views/datasource/Edit.vue"),
          meta: {
            title: "Edit Datasource"
          }
        },
        {
          path: "datasources/:id/items",
          name: "datasource-items",
          component: () => import("@/views/datasource/Items.vue"),
          meta: {
            title: "Datasource Items"
          }
        },
      ]
    },
    {
      path: "/e/:eventId/:bookingId?",
      name: "event-booking",
      component: () => import("@/views/event/Booking.vue"),
      meta: {
        title: "Event Booking"
      }
    },
    {
      path: "/:workspaceSlug/:eventId/:bookingId?",
      name: "event-booking-public",
      component: () => import("@/views/event/Booking.vue"),
      meta: {
        title: "Event Booking",
        isPublicBooking: true
      }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import( /* webpackChunkName: "about" */ "@/views/About.vue")
    },
    {
      path: '*',
      component: () => import("@/views/404.vue"),
    }
  ]
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
});

export default router;